import React, { useState } from 'react';

import { useParams } from "react-router-dom";
import { useList } from '../../hooks/listHook';
import EmptyList from '../../useful/EmptyList';
import { withAuthorization } from '../../session';
import MatchesListForm from './MatchesListForm';
import { } from '@fortawesome/free-solid-svg-icons';
import MatchesListItem from './MatchesListItem';
import TournamentLoader from '../../loaders/TournamentLoader';
import Moment from 'react-moment';
import moment from 'moment';
import ModalInfo from '../../useful/ModalInfo';
import ModalForm from '../../useful/ModalForm';

const MatchesList = (props) => {

    const { tournament_uid } = useParams(); // tournament uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { tournament, teams, players } = props;

    const { loading, list: matches } = useList(props.firebase.matchList(userId, tournament_uid), tournament_uid);

    const [matchday, setMatchday] = useState(0);
    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    const [matchForm, setMatchForm] = useState({ show: false, match: {} });

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const showMatchForm = (match) => {
        setMatchForm({ show: true, match: match });
    }

    const loadingView = [1, 2, 3, 4].map((item) => {
        return (
            <div key={item} className="col-12 col-sm-6 col-md-4 col-lg-3 pr-1 pl-1 mb-2">
                <div className="col bg-light border border-white rounded-lg p-2 m-0">
                    <TournamentLoader />
                </div>
            </div>
        )
    });

    let matchdayList = matches.map((item) => item.matchday);
    matchdayList.sort((a, b) => a.index - b.index);
    matchdayList = matchdayList.map((item) => item.title);
    matchdayList = [...new Set(matchdayList)]

    const matchdayValue = matchdayList[matchday];
    const matchesList = matches.filter((item) => item.matchday.title === matchdayValue);

    let dateList = matchesList.map((item) => {
        if (item.date) {
            const d = new Date(item.date);
            return moment(d).format("YYYYMMDD");
        }
        return '-';
    });
    dateList = [... new Set(dateList)];
    dateList.sort();

    const listView = (matchesList && matchesList.length > 0) ?
        dateList.map((date) => {

            let matchesByDate = matchesList.filter((m) => {

                let mDate = '-';
                if (m.date) {
                    const d = new Date(m.date);
                    mDate = moment(d).format("YYYYMMDD");
                }

                return date === mDate;
            });
            matchesByDate.sort((a, b) => a.date - b.date);

            const matchesItems = matchesByDate.map((item, i) => {
                return (
                    <MatchesListItem key={i} match={item} teams={teams} showMatchForm={showMatchForm} />
                )
            });

            return (
                <div key={date} className="row m-0 border-bottom mb-2">
                    <div className="col-12 small font-italic text-secondary">
                        {(date === '-') ?
                            <span className="">sin fecha</span>
                            :
                            <Moment className="font-italic " element="span" parse="YYYYMMDD" format="ddd D [de] MMM YYYY">{date}</Moment>}
                    </div>
                    <table className="col-12">
                        {/* <tbody> */}
                        {matchesItems}
                        {/* </tbody> */}
                    </table>
                </div>
            )
        })
        :
        <EmptyList />

    return (
        <div className="">
            <div className="row justify-content-between m-0 mb-2 small">
                <span className="col-auto align-self-center font-weight-bolder m-0 p-0">
                    Listado de Partidos
                </span>

                <select value={matchday} onChange={(e) => setMatchday(e.target.value)} className="form-control form-control-sm col-auto" style={{ width: 'auto' }} >
                    {matchdayList.map((item, i) =>
                        <option key={i} value={i}>{item}</option>)
                    }
                </select>
            </div>

            {(!loading) ?
                <div >
                    {listView}
                </div>
                :
                <div className="row m-0">
                    {loadingView}
                </div>
            }

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

            <ModalForm
                show={matchForm.show}
                onClose={() => setMatchForm({ show: false, match: {} })}
            >
                <MatchesListForm tournament={tournament} teams={teams} players={players}
                    matches={matches} match={matchForm.match}
                    onClose={() => setMatchForm({ show: false, match: {} })} showModal={showModal} />
            </ModalForm>

        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(MatchesList);